import React, { Component } from 'react';
import './App.css';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import VideoPlayer from "./VideoPlayer";
import TextField from '@material-ui/core/TextField';
import axios from "axios";
import Divider from '@material-ui/core/Divider'
import Typography from '@material-ui/core/Typography';
import VideoInfo from "./VideoInfo";
// Bitmovin
import uuid from 'uuid/v4';
import {
    osVersion,
    isChrome,
    isChromium,
    isFirefox,
    isOpera
} from 'react-device-detect';

// import sampleResponse from "./sampleResponse"
import CardContent from '@material-ui/core/CardContent'
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Tooltip from '@material-ui/core/Tooltip';
import FormGroup from '@material-ui/core/FormGroup'
import PlayArrow from '@material-ui/icons/PlayArrow'
import FastForward from '@material-ui/icons/FastForward'
import PlayCircleFilled from '@material-ui/icons/PlayCircleFilled'
import PauseCircleFilled from '@material-ui/icons/PauseCircleFilled'
import OpenInNew from '@material-ui/icons/OpenInNew'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import green from '@material-ui/core/colors/green'
import CircularProgress from '@material-ui/core/CircularProgress'
import Input from '@material-ui/core/Input'
import Fab from '@material-ui/core/Fab';
import qs from "qs";
import NetworkInfo from "./NetworkInfo";


import ReactGA from 'react-ga';

import { urlConfig } from './config'
import ContentSearch from "./ContentSearch";
import ErrorBoundary from "./ErrorBoundry";
import ContentService from "./Services/ContentService";
import showSnackBar from "./Utilities/SnackbarHelper";
import { ERROR } from "./constants";

import {
    generateSubtitleTrack
} from "./Utilities/getSubtitles";

const styles = theme => ({
    divider: {
        height: theme.spacing(2),
    },
    container: {
        position: 'relative',
    },
});


class Container extends Component {

    constructor(props) {
        super(props);
        let parsed = qs.parse(this.props.location.search);

        if (parsed["?cid"] && parsed["?cid"].length > 0) {
            this.cid = parsed["?cid"];
        } else {
            this.cid = '';
        }

        if (parsed["t"] && parsed["t"].length > 0) {
            this.startTime = parsed["t"];
        } else {
            this.startTime = 0;
        }

        this.state = {
            suggestions: [],
            loadingVideo: false,
            selectedValue: 'AUTO',
            selectedQuality: 7,
            cid: this.cid,
            videojsConfig: {},
            clipData: {},
            drmData: {},
            errorMessages: {},
            startTime: this.startTime,
            startTimeMinutes: 0,
            isClearyKeyContent: false,
            DrmType: null
        };


        this.handleSuggestionSelect = this.handleSuggestionSelect.bind(this);
    }

    handleChangeRadio = event => {
        this.setState({ selectedFormat: event.target.value });
    };

    handleChange = cid => event => {
        this.setState({
            [cid]: event.target.value,
        }, function () {

        });
    };

    handleChangeUrl = url => event => {
        this.setState({
            [url]: event.target.value,
        }, function () {

        });
    };

    handleChangeStartTime = startTime => event => {
        this.setState({
            [startTime]: event.target.value,
        }, function () {

        });
    };

    handleSuggestionSelect(event) {
        this.setState({ cid: event }, () => {
            this.playVideo();
        })
    }

    configureVideo(drmData,clipData,selectedFormat) {

        let videoPlayerConfig = {
            autoplay: true,
            controls: true
        };
        if (drmData) {
            // setup Bitmovin source data

            let dashUrl = "";
            let hlsUrl = "";

            if (selectedFormat === "dashVp9") {
                if (drmData.dashVp9Url && drmData.dashVp9Url !== "") {
                    dashUrl = drmData.dashVp9Url;
                }
            }

            if (selectedFormat === "dashVp6") {
                if (drmData.dashVp6Url && drmData.dashVp6Url !== "") {
                    dashUrl = drmData.dashVp6Url;
                }
            }

            if (selectedFormat === "hlsVp6") {
                if (drmData.hlsVp6Url && drmData.hlsVp6Url !== "") {
                    hlsUrl = drmData.hlsVp6Url;
                }
            }

            let replacer = "https://premiumvideo-internal.vuclip.com";
            if (dashUrl !== "") {
                dashUrl = dashUrl.replace("https://gcpvuclip-a.akamaihd.net", replacer);
            }
            if (hlsUrl !== "") {
                hlsUrl = hlsUrl.replace("https://gcpvuclip-a.akamaihd.net", replacer);
            }

            videoPlayerConfig.sourceConfig = {
                dash: dashUrl,
                hls: hlsUrl,
                subtitleTracks: generateSubtitleTrack(clipData.entity.data.asset.subtitles)
            };

            if (drmData.drmIndustryType === "Widevine") {
                // Standard DRM
                const Widevine_level = isChrome || isChromium || isFirefox || isOpera;
                const headerList = {
                    os_ver: osVersion,
                    hdcp_level: null,
                    drm_level: Widevine_level ? 'l3' : null,
                    actionType: 's',
                    lang_id: 'en',
                    'x-request-id': uuid(),
                    languageId: 'en',
                    ccode: 'ZA',
                    'x-session-id': uuid(),
                    'User-Agent': navigator.userAgent,
                    'x-client': 'browser',
                    Authorization: 'eyJhbGciOiJBMTI4S1ciLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0.5jq95HEm1BO2_oCvmZMgjE5gmmEwP9tqrfgROEjHjzmQcF0B12YOdw.04Fx3liTTGRiFAD2z-hh3w.ByaWQfAcNj3LeRvGTH6-MxI4wpsfA81XudlSjNqXpWbCEhJG2SkniPRVP0hISvJIScR6fGGp4ckeK6UvdIRSiIYfM0JyzKlgpRSF1_OiE1dRrxrsW1vaZASx67D-SEnTXq9lKxvKfiqoXUDgbkVmi9u8Z1gA3x9t6EGcNb1KLsm_IV2CYSrN9DzfQSVrE2QfrJeZUsHXGLbTpp4N3EIgA5MoKbVIUUpJA3yICNm3f90.O7eOX31ocDEEOuH30OYsMQ'
                };

                let clipLicenseUrl = `${urlConfig.drmServiceUrl}/v1/license/${this.state.cid}`;

                videoPlayerConfig.sourceConfig = {
                    ...videoPlayerConfig.sourceConfig,
                    drm: {
                        immediateLicenseRequest: true,
                        widevine: {
                            LA_URL: clipLicenseUrl,
                            headers: headerList
                        },
                        playready: {
                            LA_URL: clipLicenseUrl,
                            headers: headerList
                        },
                        fairplay: {
                            LA_URL: clipLicenseUrl,
                            certificateURL: 'https://license.pallycon.com/ri/fpsKeyManager.do?siteId=W1RU',
                            headers: headerList,
                            prepareContentId(contentId) {
                                let startIndex = contentId.indexOf('skd://');
                                startIndex =
                                    startIndex === -1
                                        ? contentId
                                        : contentId.substring(startIndex + 6);
                                return startIndex;
                            },
                            prepareCertificate(rawResponse) {
                                const responseText = String.fromCharCode.apply(
                                    null,
                                    new Uint8Array(rawResponse)
                                );
                                const raw = window.atob(responseText);
                                const rawLength = raw.length;
                                const certificate = new Uint8Array(
                                    new ArrayBuffer(rawLength)
                                );

                                // eslint-disable-next-line no-plusplus
                                for (let i = 0; i < rawLength; i++)
                                    certificate[i] = raw.charCodeAt(i);

                                return certificate;
                            },
                            useUint16InitData: true
                        }
                    }
                }

            } else if (drmData.drmIndustryType === "Clearkey") {
                // Internal DRM: specify the clearKey
                videoPlayerConfig.sourceConfig = {
                    ...videoPlayerConfig.sourceConfig,
                    drm: {
                        clearkey: [{
                            key: drmData.playerToken,
                            kid: '30303030303030303030303030303033'
                        }]
                    }
                }
            }

            videoPlayerConfig.cid = this.state.cid;

            let minToSec = parseInt(this.state.startTimeMinutes) * 60;
            videoPlayerConfig.startTime = parseInt(this.state.startTime) + minToSec;
            // videoPlayerConfig.sources[0].image = `${urlConfig.thumbnailUrlBase}?cid=${this.state.cid}&t=thumb800x450`;

            this.setState({
                clipData: clipData,
                drmData: drmData,
                selectedFormat: selectedFormat,
                videoPlayerConfig: videoPlayerConfig,
                loadingVideo: false,
                DrmType: drmData.drmType
            }, () => {
                this.forceUpdate();
            })

        } else {
            this.setState({
                loadingVideo: false
            }, () => {
                this.forceUpdate();
            })
        }
    }

    playLoadedVideo(format) {
        let self = this;

        let drmData = this.state.drmData;
        let clipData = this.state.clipData;

        this.setState({
            drmData: {},
            clipData: {},
            selectedFormat: '',
            videoPlayerConfig: {},
            loadingVideo: true
        }, () => {
            window.setTimeout(() => {
                self.configureVideo(drmData,clipData,format)
            }, 500)
        })

    }

    playVideo = function (event) {
        const isSafari = window && window.safari;
        this.setState({
            videojsConfig: {}
        });

        let self = this;

        if (this.state.cid && this.state.cid.length >= 5) {


            this.setState({
                clipData: {},
                drmData: {},
                selectedFormat: '',
                videoPlayerConfig: {},
                loadingVideo: true
            })

            self.setState({
                errorMessages: []
            });

            ContentService.getContent(this.state.cid)
                .then(function (response) {
                    self.setState({ clipData: {} });

                    if (response && response.data) {
                        if (response.data.status === "SUCCESS") {
                            if (response.data.data && response.data.data.drm) {
                                let drmData = response.data.data.drm;
                                let clipData = response.data.data.clipData;
                                // self.configureVideo(drmData, clipData, "dashVp9");

                                const selectedFormatToPlay = isSafari !== undefined ? 'hlsVp6' : 'dashVp9';//set default value based on browser detection.
                                self.configureVideo(drmData,clipData,selectedFormatToPlay); //SAM 2020-12-09 changed: default set to vp6 

                            } else {
                                self.setState({
                                    loadingVideo: false,
                                    errorMessages: [...self.state.errorMessages, `Could not get DRM Data.`]
                                });
                            }
                        } else {
                            if (response.data.message) {
                                self.setState({
                                    loadingVideo: false,
                                    errorMessages: [...self.state.errorMessages, response.data.message]
                                });
                            } else {
                                self.setState({
                                    loadingVideo: false,
                                    errorMessages: [...self.state.errorMessages, `Could not get Content Data. No error message`]
                                });
                            }
                        }
                    } else {
                        self.setState({
                            loadingVideo: false,
                            errorMessages: [...self.state.errorMessages, `Could not get Content Data. No response.`]
                        });
                    }

                })
                .catch(function (error) {
                    if (error && error.data && error.data.message) {
                        self.setState({
                            loadingVideo: false,
                            errorMessages: [...self.state.errorMessages, error.data.message]
                        });
                    } else {
                        self.setState({
                            loadingVideo: false,
                            errorMessages: [...self.state.errorMessages, `Could not get Content Data. HTTP error, no message.`]
                        });
                    }
                });
        } else {

        }



    };

    componentDidMount() {
        this.playVideo();
    }

    render() {
        const { classes, theme } = this.props;
        const flex = { flexGrow: 1 };

        const containerStyle = {
            minHeight: '75vh'
        };

        const radioStyle = {
            marginRight: '-12px'
        };

        const buttonProgress = {
            color: green[500],
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: -12,
            marginLeft: -12,
        };

        const progressButtonWrapper = {
            position: 'relative',
        };

        const inputStyle = {
            maxWidth: '4rem'
        };

        const cidInputStyle = {
            maxWidth: '7rem'
        };


        return (
            <Grid container spacing={0}>

                <Grid item xs={12}>
                    <ContentSearch inputText={''}
                        handleSuggestionSelect={this.handleSuggestionSelect.bind(this)}
                        inputPlaceholder={'Search with Clip Title here'} />

                </Grid>

                <Grid item xs={12}>
                    <Paper style={containerStyle}>

                        <Grid container spacing={0}>
                            <Grid item xs={12} sm={10}>

                                {this.state && this.state.videoPlayerConfig && this.state.videoPlayerConfig.autoplay &&
                                    <div>
                                        <VideoPlayer {...this.state.videoPlayerConfig} />
                                    </div>
                                }

                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Paper>
                                    <CardContent>
                                        <form onSubmit={this.playVideo.bind(this)}>
                                            <FormGroup row>
                                                <Input style={cidInputStyle}
                                                    id="cid" autoFocus
                                                    label="CID" placeholder="Enter a CID"
                                                    value={this.state.cid}
                                                    onChange={this.handleChange('cid')}
                                                    required={true}
                                                />
                                                <span style={progressButtonWrapper}>

                                                    <Fab type="submit"
                                                        size="small"
                                                        color="primary"
                                                        onClick={this.playVideo.bind(this)}
                                                        disabled={this.state.loadingVideo}>
                                                        <PlayArrow />
                                                    </Fab>

                                                    {this.state.loadingVideo &&
                                                        <CircularProgress size={24} style={buttonProgress} />}

                                                </span>
                                            </FormGroup>
                                        </form>


                                        {this.state.clipData && this.state.clipData.entity &&
                                            <span>
                                                {this.state.clipData.entity.data.shortTitle.length > 25 &&
                                                    <Tooltip title={this.state.clipData.entity.data.shortTitle}>
                                                        <Typography variant="h6"
                                                            style={{ marginTop: '10px' }}>{this.state.clipData.entity.data.shortTitle.substr(0, 25)} ...</Typography>
                                                    </Tooltip>}
                                                {this.state.clipData.entity.data.shortTitle.length <= 25 &&
                                                    <Typography variant="h6"
                                                        style={{ marginTop: '10px' }}>{this.state.clipData.entity.data.shortTitle} </Typography>}
                                            </span>
                                        }
                                        {this.state.DrmType && <><label style={{ padding: 0, fontWeight: 800, fontSize: 16 }}>Drm Type: </label><label>{this.state.DrmType}</label></>}

                                        {this.state.drmData && this.state.drmData.dashVp9Url && this.state.drmData.dashVp9Url !== "" &&
                                            <ListItem divider>
                                                <FormControl>
                                                    <FormGroup row>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                            onClick={this.playLoadedVideo.bind(this, 'dashVp9')}
                                                            checked={this.state.selectedFormat === 'dashVp9'}
                                                            value="dashVp9"
                                                            control={<Radio icon={<PlayCircleFilled />}
                                                                checkedIcon={
                                                                    <PauseCircleFilled />} />}
                                                            label="Dash VP9" />
                                                        <FormGroup row>
                                                            <TextField
                                                                id="dashVp9Url"
                                                                label="dashVp9Url"
                                                                value={this.state.drmData.dashVp9Url.replace("https://gcpvuclip-a.akamaihd.net", "https://premiumvideo-internal.vuclip.com")}

                                                            />
                                                        </FormGroup>

                                                    </FormGroup>

                                                </FormControl>
                                            </ListItem>
                                        }

                                        {this.state.drmData && this.state.drmData.dashVp6Url && this.state.drmData.dashVp6Url !== "" &&
                                            <ListItem divider>

                                                <FormControl>

                                                    <FormGroup row>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                            onClick={this.playLoadedVideo.bind(this, 'dashVp6')}
                                                            checked={this.state.selectedFormat === 'dashVp6'}
                                                            value="dashVp6"
                                                            control={<Radio icon={<PlayCircleFilled />}
                                                                checkedIcon={
                                                                    <PauseCircleFilled />} />}
                                                            label="Dash VP6" />
                                                        <FormGroup row>
                                                            <TextField
                                                                id="dashVp6Url"
                                                                label="dashVp6Url"
                                                                value={this.state.drmData.dashVp6Url.replace("https://gcpvuclip-a.akamaihd.net", "https://premiumvideo-internal.vuclip.com")}

                                                            />
                                                        </FormGroup>

                                                    </FormGroup>

                                                </FormControl>
                                            </ListItem>}

                                        {this.state.drmData && this.state.drmData.hlsVp6Url && this.state.drmData.hlsVp6Url !== "" &&
                                            <ListItem divider>

                                                <FormControl>

                                                    <FormGroup row>
                                                        <FormControlLabel onChange={this.handleChangeRadio}
                                                            onClick={this.playLoadedVideo.bind(this, 'hlsVp6')}
                                                            checked={this.state.selectedFormat === 'hlsVp6'}
                                                            value="hlsVp6"
                                                            control={<Radio icon={<PlayCircleFilled />}
                                                                checkedIcon={
                                                                    <PauseCircleFilled />} />}
                                                            label="Hls VP6" />
                                                        <FormGroup row>
                                                            <TextField
                                                                id="hlsVp6Url"
                                                                label="hlsVp6Url"
                                                                value={this.state.drmData.hlsVp6Url.replace("https://gcpvuclip-a.akamaihd.net", "https://premiumvideo-internal.vuclip.com")}

                                                            />
                                                        </FormGroup>

                                                    </FormGroup>

                                                </FormControl>
                                            </ListItem>}

                                    </CardContent>

                                    <Divider />

                                    {this.state && this.state.cid && this.state.drmData && this.state.drmData.drmType &&
                                        <List component="nav">

                                            <React.Fragment>

                                                <ListItem divider>
                                                    <form onSubmit={this.playVideo.bind(this)}>
                                                        <FormGroup row>
                                                            <TextField style={inputStyle}
                                                                id="seek"
                                                                label="Seek Minutes" placeholder="Enter Minutes"
                                                                value={this.state.startTimeMinutes}
                                                                onChange={this.handleChangeStartTime('startTimeMinutes')}
                                                                required={true}
                                                            />

                                                            <TextField style={inputStyle}
                                                                id="seek"
                                                                label="Seek Seconds" placeholder="Enter seconds"
                                                                value={this.state.startTime}
                                                                onChange={this.handleChangeStartTime('startTime')}
                                                                required={true}
                                                            />

                                                            <span style={progressButtonWrapper}>

                                                                <Fab type="submit"
                                                                    size="small"
                                                                    onClick={this.playVideo.bind(this)}
                                                                    disabled={this.state.loadingVideo}>
                                                                    <FastForward />
                                                                </Fab>

                                                                {this.state.loadingVideo &&
                                                                    <CircularProgress size={24} style={buttonProgress} />}
                                                            </span>
                                                        </FormGroup>
                                                    </form>
                                                </ListItem>
                                            </React.Fragment>

                                        </List>}
                                </Paper>
                            </Grid>
                        </Grid>
                        {this.state.errorMessages && this.state.errorMessages.length > 0 &&
                            <Grid container spacing={0}>
                                <Grid item xs={1}></Grid>
                                <Grid item xs={10}>
                                    {this.state.errorMessages.map(function (errorMessage, index) {
                                        return (<Typography variant={`h6`} key={index} color='secondary'>
                                            Error : {errorMessage}
                                        </Typography>)
                                    })}
                                </Grid>
                                <Grid item xs={1}></Grid>
                            </Grid>}

                        {this.state.clipData && this.state.clipData !== {} &&
                            <ErrorBoundary message={'Unable to load clip information.'}>
                                <VideoInfo clipData={this.state.clipData} />
                            </ErrorBoundary>
                        }


                    </Paper>
                </Grid>

                <NetworkInfo />
            </Grid>
        );
    }
}


Container.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};
export default withStyles(styles, { withTheme: true })(Container);
